// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30UNm","left":"styles_left__1-KA3"};